exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._35d6h{padding-left:20px;padding-right:20px;width:1000px;margin:auto}._3Qmpj{max-width:1000px;padding:30px 0;margin:20px auto;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.PvcJT{width:440px;min-width:440px}._3xDnN{height:auto;width:100%}._2X6On{padding:0 10px 0 20px;font-size:18px}._3Esix{font-size:35px;font-weight:600;line-height:45px;margin:0 0 15px}._2CBFH{text-align:center}._13P6C{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 25%;flex:1 1 25%;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;padding:6px 0 8px;font-weight:400;text-align:left}._1nP5N{cursor:pointer;color:#2196f3;text-decoration:none}._1nP5N:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"root": "_35d6h",
	"container": "_3Qmpj",
	"imageContainer": "PvcJT",
	"image": "_3xDnN",
	"content": "_2X6On",
	"title": "_3Esix",
	"makeContainer": "_2CBFH",
	"makeItem": "_13P6C",
	"link": "_1nP5N"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/not-found/NotFound.css
// module id = 3315
// module chunks = 38